import { ADMIN as ADMIN_LABELS } from 'constants/textConstants'

export const DASHBOARD_ROUTES = {
  physicianDashboards: {
    phymanagedata: {
      title: 'Manage Data',
      url: '/phy/manage-data',
      fullType: 'Physician',
      order: 1,
      showNavbarButtons: true,
      subroutes: ['/market-library', '/organization-library', '/custom-module', '/blend-market-data', '/upload'],
    },
    phyaag: { title: 'At-A-Glance', url: '/phy/at-a-glance', fullType: 'Physician', order: 2, showNavbarButtons: true },
    physurveyreport: { title: 'Survey Report', url: '/phy/survey-report', fullType: 'Physician', order: 3, showNavbarButtons: true },
    phymarketpositioning: {
      title: 'Market Positioning',
      url: '/phy/market-positioning',
      fullType: 'Physician',
      order: 4,
      showNavbarButtons: true,
      subroutes: ['/incumbent'],
    },
    phymarketmodeling: {
      title: 'Market Modeling',
      url: '/phy/market-modeling',
      fullType: 'Physician',
      order: 5,
      showNavbarButtons: true,
      subroutes: ['/specialty-group', '/specialty', '/incumbent'],
    },
    phymarkettrends: { title: 'Market Trends', url: '/phy/market-trends', fullType: 'Physician', order: 6, showNavbarButtons: true },
    phyoppassessmt: {
      title: 'Opportunity Assessment',
      url: '/phy/opportunity-assessment',
      fullType: 'Physician',
      order: 7,
      showNavbarButtons: true,
    },
  },
  appDashboards: {
    appmanagedata: {
      title: 'Manage Data',
      url: '/app/manage-data',
      fullType: 'Advanced Practice Provider',
      order: 1,
      showNavbarButtons: true,
      subroutes: ['/market-library', '/organization-library', '/custom-module', '/blend-market-data', '/upload'],
    },
    appaag: { title: 'At-A-Glance', url: '/app/at-a-glance', fullType: 'Advanced Practice Provider', order: 2, showNavbarButtons: true },
    appsurveyreport: { title: 'Survey Report', url: '/app/survey-report', fullType: 'Advanced Practice Provider', order: 3, showNavbarButtons: true },
    appmarketpositioning: {
      title: 'Market Positioning',
      url: '/app/market-positioning',
      fullType: 'Advanced Practice Provider',
      order: 4,
      showNavbarButtons: true,
      subroutes: ['/incumbent'],
    },
    appmarketmodeling: {
      title: 'Market Modeling',
      url: '/app/market-modeling',
      fullType: 'Advanced Practice Provider',
      order: 5,
      showNavbarButtons: true,
      subroutes: ['/practice-setting', '/specialty', '/incumbent'],
    },
    appmarkettrends: { title: 'Market Trends', url: '/app/market-trends', fullType: 'Advanced Practice Provider', order: 6, showNavbarButtons: true },
  },
  admin: {
    admintemplate: {
      title: ADMIN_LABELS.NAV.TABS.TEMPLATES,
      url: '/admin/templates',
      fullType: 'Administrator',
      order: 1,
      showNavbarButtons: true,
    },
    adminmessages: {
      title: ADMIN_LABELS.NAV.TABS.MESSAGES_TOOLTIPS,
      url: '/admin/messages',
      fullType: 'Administrator',
      order: 2,
      showNavbarButtons: true,
    },
    adminmarketlibrary: {
      title: ADMIN_LABELS.NAV.TABS.MARKET_LIBRARY,
      url: '/admin/market-library',
      fullType: 'Administrator',
      order: 3,
      showNavbarButtons: true,
    },
  },
}

export const SIDEBAR_ROUTES = {}
